// Generated by art-masters/v10/orbit.sh — 36 frames of the Mountain orbit (10° each).
import type { ImageSourcePropType } from 'react-native';
export const ORBIT_FRAMES: ImageSourcePropType[] = [
  require('../../assets/v10/mountain/orbit_cut/f00.png'),
  require('../../assets/v10/mountain/orbit_cut/f01.png'),
  require('../../assets/v10/mountain/orbit_cut/f02.png'),
  require('../../assets/v10/mountain/orbit_cut/f03.png'),
  require('../../assets/v10/mountain/orbit_cut/f04.png'),
  require('../../assets/v10/mountain/orbit_cut/f05.png'),
  require('../../assets/v10/mountain/orbit_cut/f06.png'),
  require('../../assets/v10/mountain/orbit_cut/f07.png'),
  require('../../assets/v10/mountain/orbit_cut/f08.png'),
  require('../../assets/v10/mountain/orbit_cut/f09.png'),
  require('../../assets/v10/mountain/orbit_cut/f10.png'),
  require('../../assets/v10/mountain/orbit_cut/f11.png'),
  require('../../assets/v10/mountain/orbit_cut/f12.png'),
  require('../../assets/v10/mountain/orbit_cut/f13.png'),
  require('../../assets/v10/mountain/orbit_cut/f14.png'),
  require('../../assets/v10/mountain/orbit_cut/f15.png'),
  require('../../assets/v10/mountain/orbit_cut/f16.png'),
  require('../../assets/v10/mountain/orbit_cut/f17.png'),
  require('../../assets/v10/mountain/orbit_cut/f18.png'),
  require('../../assets/v10/mountain/orbit_cut/f19.png'),
  require('../../assets/v10/mountain/orbit_cut/f20.png'),
  require('../../assets/v10/mountain/orbit_cut/f21.png'),
  require('../../assets/v10/mountain/orbit_cut/f22.png'),
  require('../../assets/v10/mountain/orbit_cut/f23.png'),
  require('../../assets/v10/mountain/orbit_cut/f24.png'),
  require('../../assets/v10/mountain/orbit_cut/f25.png'),
  require('../../assets/v10/mountain/orbit_cut/f26.png'),
  require('../../assets/v10/mountain/orbit_cut/f27.png'),
  require('../../assets/v10/mountain/orbit_cut/f28.png'),
  require('../../assets/v10/mountain/orbit_cut/f29.png'),
  require('../../assets/v10/mountain/orbit_cut/f30.png'),
  require('../../assets/v10/mountain/orbit_cut/f31.png'),
  require('../../assets/v10/mountain/orbit_cut/f32.png'),
  require('../../assets/v10/mountain/orbit_cut/f33.png'),
  require('../../assets/v10/mountain/orbit_cut/f34.png'),
  require('../../assets/v10/mountain/orbit_cut/f35.png'),
];

// Daylight grade of the same 36 frames — art-masters/v10/orbit_day_grade.py (free, local).
export const ORBIT_FRAMES_DAY: ImageSourcePropType[] = [
  require('../../assets/v10/mountain/orbit_day_cut/f00.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f01.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f02.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f03.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f04.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f05.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f06.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f07.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f08.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f09.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f10.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f11.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f12.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f13.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f14.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f15.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f16.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f17.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f18.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f19.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f20.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f21.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f22.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f23.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f24.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f25.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f26.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f27.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f28.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f29.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f30.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f31.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f32.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f33.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f34.png'),
  require('../../assets/v10/mountain/orbit_day_cut/f35.png'),
];
